/* import Vue from 'vue'
import Axios from 'axios'
import store from '../store'
import { Toast } from 'vant'
import i18n from '../i18n';
import { getIsSellerAjax } from '../api/index'; */

import router from '../router'
import base64 from '@/tools/base64';
import i18n from '../i18n';
import {getBrowserFingerprint, isBondo} from '../util';

//解析URL参数
export const getParams =  function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}
//解析URL参数
export const getParamsHash =  function(name) {
    var url = location.href;
    var i = url.indexOf('?');
    if (i == -1) return;
    var querystr = url.slice(i + 1);
    var arr1 = querystr.split('&');
    var arr2 = new Object();
    for (i in arr1) {
        var t = arr1[i].split('=');
        arr2[t[0]] = t[1];
    }
    return arr2[name];
}

export const getUrlParams=  function(name) {
    var url = location.href;
    url = decodeURIComponent(url)
    var i = url.indexOf('?');
    if (i == -1) return;
    var querystr = url.slice(i + 1);
    var arr1 = querystr.split('&');
    var arr2 = new Object();
    for (i in arr1) {
        var t = arr1[i].split('=');
        arr2[t[0]] = t[1];
    }
    return arr2[name];
}

// 获取系统语言
export const getSysLang = ()=>{
    let jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
    let lang = jsSrc.substr(0,2);
    if (jsSrc == 'zh-mo' || jsSrc == 'zh-tw' || jsSrc == 'zh-hk' || jsSrc == 'zh-rHK' || jsSrc.indexOf("zh-hant") != -1) {
        lang = 'zh-rHK';
    }
    if(isBondo()) {
      lang = 'en'
    }
    return lang;
}
const getDidObj = () => {
  const fingerprintResult = getBrowserFingerprint()
  let didObj = {}
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const safari = /safari/i.test(navigator.userAgent);
  console.log(`output->did`,isIOS, safari)
  console.log(`output->did`,fingerprintResult.fingerprint)
  if(isIOS || safari) {
      didObj = {
          deviceId: 'pwa_'+(localStorage.getItem('_did') || Date.now()),
      }
  } else {
      didObj = {
          deviceId: 'pwa_'+fingerprintResult.fingerprint,
          appGeneratedId: 'pwa_'+(localStorage.getItem('_did') || Date.now())
      }
  }
  console.log(`output->did`,didObj)
  return didObj
}
// 参数加密获取到公参
export const base64Jiami =  function({token}){
    var base1 = new base64();
    let jsonData={
        "systoken":token,
        "sysLanguage":getSysLang(),
        "platform":'pc',
        "unixTime": new Date().getTime(),
        ...getDidObj()
    }
    let str=JSON.stringify(jsonData)
    return base1.encode(str);
}

export const randomNumber = () => {
  // 生成一个随机数，范围在 100000（包括）到 999999（不包括）之间
  const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
  return randomSixDigitNumber;
}


const getBondoDidObj = () => {
  const fingerprintResult = getBrowserFingerprint()
  let didObj = {}
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const safari = /safari/i.test(navigator.userAgent);
  console.log(`output->did`,isIOS, safari)
  console.log(`output->did`,fingerprintResult.fingerprint)
  if(isIOS || safari) {
    didObj = {
      bondo_custom_id: 'pwa_'+(localStorage.getItem('_did') || Date.now()),
    }
  } else {
    didObj = {
      bondo_custom_id: 'pwa_'+fingerprintResult.fingerprint,
      appGeneratedId: 'pwa_'+(localStorage.getItem('_did') || Date.now())
    }
  }
  console.log(`output->did`,didObj)
  return didObj
}

export const base64JiamiBondo = function ({token, systoken = null}) {
  const base1 = new base64();
  let lang = getSysLang();
  // lang = 'en'
  let jsonData={
    bondo_api: token,
    bondo_system: systoken,
    bondo_language_n:lang,
    bondo_language_p:lang,
    bondo_device_1: 'web',
    bondo_name: "bondo",
    bondo_date: new Date().getTime(),
    bondo_nonce: randomNumber(),
    bondo_version:'1.0.0',
    bondo_code:'100',
    ...getBondoDidObj()
  }
  let str=JSON.stringify(jsonData)
  return base1.encode(str);
}

//缓存读取用户信息
export const getUserInfoCache =  function(path){
    //先获取链接信息
    let log_usin = getParamsHash('log_usin');//链接带有
    let userInfo = localStorage.getItem("userInfo");//缓存

    try {
        if(log_usin){
            let info = decodeURIComponent(log_usin);
            let logUsin = JSON.parse(info);
            // convertStatus 1：需要反解 ； 0：不反解，
            if (logUsin.convertStatus && logUsin.convertStatus == '1') {
                const base64Instance = new base64();
                let token = base64Instance.decode(logUsin.token);
                logUsin.token = token;
            }
            localStorage.setItem("userInfo",JSON.stringify(logUsin));
            return logUsin;
        }else if(userInfo) {
            let info = decodeURIComponent(encodeURIComponent(userInfo));
            let a = JSON.parse(info);
            return a;
        }
        return null;
    } catch (error) {
        return null;
    }

}

//退出登录
export const exitLogin =() => {
    localStorage.setItem("userInfo", '');
    localStorage.removeItem("userInfo");
    router.push({
        path: '/login'
    })
}

// 判断是否safari
export const isSafari = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // alert(userAgent);
    return (/safari/i).test(userAgent) && !(/chrome/i).test(userAgent);
}


// 得到apiCommon

export  function getDefaultApiCommon(){
     var base1 = new base64();
       let jsonData={
                "systoken":'',
                "sysLanguage":i18n.locale,
                "platform":'bcnewpay',
                "unixTime":new Date().getTime()
         };
      let str=JSON.stringify(jsonData);
    return base1.encode(str);

}



// WEBPACK FOOTER //
// ./src/tools/common.js